import { render, staticRenderFns } from "./Punch.vue?vue&type=template&id=6f1f5234&scoped=true"
import script from "./Punch.vue?vue&type=script&lang=js"
export * from "./Punch.vue?vue&type=script&lang=js"
import style0 from "./Punch.vue?vue&type=style&index=0&id=6f1f5234&prod&lang=scss&scoped=true"
import style1 from "./Punch.vue?vue&type=style&index=1&id=6f1f5234&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f1f5234",
  null
  
)

export default component.exports